import { useQuery } from '@tanstack/react-query';
import { ordersService } from '../services/orders.service';
import type { OrderFilters } from '../types/orders.types';

export function useOrders(filters: OrderFilters = {}) {
  return useQuery({
    queryKey: ['orders', filters],
    queryFn: () => ordersService.getOrders(filters),
  });
}
